import React from "react";
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";

const FormButtons = ({ toggleForm, loading }) => (
  <div className="flex justify-end space-x-2">
    <button
      type="button"
      onClick={toggleForm}
      className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 focus:outline-none"
    >
      Cancel
    </button>
    <button
      type="submit"
      disabled={loading}
      className="px-3 py-1 text-xs bg-indigo-600 text-white rounded-md hover:bg-indigo-700 focus:outline-none flex justify-center items-center gap-1"
    >
      {loading ? (
        "Adding..."
      ) : (
        <>
          <IoCheckmarkDoneCircleOutline size={20} />
          Add
        </>
      )}
    </button>
  </div>
);

export default FormButtons; 